import { FC } from 'react';
import { styled } from '@mui/material';
import classNames from 'classnames';

import { useProviderNames } from '@hooks/useProviderNames';

import { Avatar, AvatarProps } from '../base';

type ProviderIconProps = Omit<AvatarProps, 'src' | 'title'> & {
  outlined?: boolean;
  providerIdentifier: string;
  title?: string;
};

const StyledAvatar = styled(Avatar)`
  background: ${({ theme }) =>
    theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.palette.text.primary};

  &.outlined {
    border: thin solid ${({ theme }) => theme.palette.divider};
  }
`;

export const ProviderIcon: FC<ProviderIconProps> = ({
  className,
  outlined,
  providerIdentifier,
  title,
  ...rest
}) => {
  const { getProviderName, getProviderImage } = useProviderNames();
  const providerImageUrl = getProviderImage(providerIdentifier);

  return (
    <StyledAvatar
      className={classNames(className, { outlined })}
      src={providerImageUrl}
      title={title || getProviderName(providerIdentifier)}
      {...rest}
    />
  );
};
